export const resizeRootEl = (
  ele: HTMLFieldSetElement,
  rootEle: HTMLElement,
  itemCount: number,
  scrollAt: number
) => {
  const hasLegend = !!ele.firstElementChild?.matches('legend');
  const lastVisibleLI =
    ele.querySelectorAll(':scope > ul > li')[
      Math.max(Math.min(scrollAt - (hasLegend ? 2 : 1), itemCount - 1), 0)
    ];

  let menuRootElHeight: number | undefined;
  if (lastVisibleLI) {
    const containerTop = ele.getBoundingClientRect().top;
    const lastVisibleLIRect = lastVisibleLI.getBoundingClientRect();
    const ulScrollTop = ele.querySelector(':scope > ul')?.scrollTop ?? 0;

    let btm = lastVisibleLIRect.bottom;
    if (itemCount >= scrollAt) {
      btm = (lastVisibleLIRect.top + lastVisibleLIRect.bottom) / 2;
    }

    menuRootElHeight = btm - containerTop + ulScrollTop;
  }

  requestAnimationFrame(() => {
    rootEle.style.height = menuRootElHeight ? `${menuRootElHeight}px` : '';
  });
};

export default { resizeRootEl };
